<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0067 4.91991C14.3333 5.24658 14.3333 5.77325 14.0067 6.09991L8.46667 11.6399C8.20667 11.8999 7.78667 11.8999 7.52667 11.6399L1.98667 6.09991C1.66 5.77325 1.66 5.24658 1.98667 4.91991C2.31334 4.59325 2.84 4.59325 3.16667 4.91991L8 9.74658L12.8333 4.91325C13.1533 4.59325 13.6867 4.59325 14.0067 4.91991Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconAccordion',
  props: {
    color: {
      type: String,
      default: '#333333',
    },
  },
}
</script>

<style scoped></style>
